import { create } from "zustand";

const useAudioStore = create((setState) => ({
    isPlaying:false,
    isPaused:false,
    tracks:[],
    source:null,
    setAudio:setState
}));

export default useAudioStore;
